'use client'

import { cn } from '@/lib/cn'
import Image from 'next/image'

interface LoginCarouselProps {
  banners: string | string[]
  className?: string
}

export function LoginCarousel({ banners, className }: LoginCarouselProps) {
  // Parse banners se for string
  const parsedBanners = typeof banners === 'string'
    ? (() => {
      try {
        return JSON.parse(banners)
      } catch {
        return [banners]
      }
    })()
    : Array.isArray(banners)
      ? banners
      : []

  // Se não houver banners válidos, não renderizar
  if (!parsedBanners.length) return null

  // Duplicar os banners para criar o efeito infinito
  const duplicatedBanners = [...parsedBanners, ...parsedBanners]

  return (
    <div className={cn('relative w-full overflow-hidden flex items-end', className)}>
      <style jsx>{`
        @keyframes scroll-left {
          0% {
            transform: translateX(0);
          }
          100% {
            transform: translateX(-50%);
          }
        }
        .animate-scroll {
          animation: scroll-left 40s linear infinite;
        }
        .animate-scroll:hover {
          animation-play-state: paused;
        }
      `}</style>

      {/* Container do carrossel infinito */}
      <div className="flex gap-4 animate-scroll">
        {duplicatedBanners.map((banner: string, index: number) => (
          <div
            key={index}
            className="flex-shrink-0 w-[200px] h-[355px] relative rounded-lg overflow-hidden shadow-lg hover:shadow-xl transition-shadow"
          >
            <Image
              src={banner}
              alt={`Banner ${(index % parsedBanners.length) + 1}`}
              fill
              className="object-cover"
              priority={index < 2}
              sizes="200px"
              quality={90}
            />
          </div>
        ))}
      </div>
    </div>
  )
}

